/**
 * Prices and rewards. Hearts (❤) are the game currency; GM is the portal currency, credited by an admin, that buys
 * hearts and wheel chances. The server is the only authority; clients use these for display.
 */
export const ECONOMY = {
  /** Hearts a new player starts with. */
  signupBonus: 10,
  /** Invite reward ("Get ❤20 for a friend"), credited once the invitee finishes their first round. */
  referralBonus: 20,
  /** Ordering a song for the table (reference: song ❤5). */
  djPrice: 5,
  /** A dedicated music video (reference: music video ❤9). */
  djVideoPrice: 9,
  /** Sending a sticker to the table (a "gesture"). */
  gesturePrice: 1,
  /** Minimum admirer price; outbidding requires current price + 1. */
  admireMinPrice: 1,
  admireMaxPrice: 100_000,
  /** The heart shop's "Send" tiles: GM 20 and ❤20 to a friend. */
  transferGm: 20,
  transferHearts: 20,
  /** Sends per player per day (ECONOMY_TZ), both currencies together. */
  transfersPerDay: 10,
} as const;

/** Heart packs of the "Buy hearts" dialog, paid with GM (reference prices), in the dialog's order. */
export const HEART_PACKS = [
  { code: 'hearts_12500', hearts: 12_500, gm: 10_000, bonusPercent: 25, badge: 'best_offer' },
  { code: 'hearts_6000', hearts: 6000, gm: 5000, bonusPercent: 20, badge: null },
  { code: 'hearts_2200', hearts: 2200, gm: 2000, bonusPercent: 10, badge: 'best_pick' },
  { code: 'hearts_500', hearts: 500, gm: 500, bonusPercent: 0, badge: null },
  { code: 'hearts_10', hearts: 10, gm: 10, bonusPercent: 0, badge: null },
] as const;

export type HeartPackCode = (typeof HEART_PACKS)[number]['code'];

export function findHeartPack(code: string) {
  return HEART_PACKS.find((p) => p.code === code);
}
